import React, { useState, useRef, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import {
    ViewIcon, ViewOffIcon
} from '@chakra-ui/icons';
import { 
    Flex, Box, Heading, FormControl, FormLabel, Input, Button, ButtonGroup, Text, CircularProgress,
    InputGroup, InputRightElement, Icon, HStack, VStack, Select,
    Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalCloseButton, ModalFooter, useToast
} from '@chakra-ui/react';
import { MdSave, MdClose } from 'react-icons/md';
import { Form, Field } from 'react-final-form';
import axios from 'axios';
import validator from "validator";
import { ROLES, ERROR_CODES } from '../../../constants';

import DropZoneWithImage from '../../../components/DropZoneWithImage';

function AddEditUserModal({ 
    company_id, companyList, actionStatus, initialRef, isOpen, onClose, apiCreateNewUser
}) {
    const [ showPassword, setShowPassword ] = useState(false);
    const [ showConfirmPassword, setShowConfirmPassword ] = useState(false);
    const [ isValidNewPassword, setIsValidNewPassword ] = useState(true);
    const [ isValidPhone, setIsValidPhone ] = useState(true);
    const [ isValidEmail, setIsValidEmail ] = useState(true);
    const [ portraitFile, setPortraitFile ] = useState(null);
    const [ isProcessing, setIsProcessing ] = useState(false);
    const [ cookies ] = useCookies(["loginCookie"]);
    const toast = useToast();

    const handlePasswordVisibility = () => setShowPassword(!showPassword);
    const handleConfirmPasswordVisibility = () => setShowConfirmPassword(!showConfirmPassword);
    console.log("--- companyList", companyList)
    useEffect(() => {
        if(!actionStatus) {
            setIsProcessing(false);
        }
    }, [actionStatus]);

    const validate = (values) => {
        const errors = {};

        if(!values.phone) {
            errors.phone = "Required";
        }
        if(!values.full_name) {
            errors.full_name = "Required";
        }
        if(!values.email) {
            errors.email = "Required";
        }
        if(!values.password) {
            errors.password = "Required";
        }
        if(!values.confirm_password) {
            errors.confirm_password = "Required";
        }

        if(values.password && values.confirm_password && (values.password !== values.confirm_password)) {
            errors.difference_password = "Required";
        }
        
        if(!values.roles) {
            errors.roles = "Required";
        }

        if(values.password) {
            const isStrongPassword = validator.isStrongPassword(values.password, {minLength: 8, minLowercase: 1, minUppercase: 1, minSymbols: 0, minNumbers: 1})
            setIsValidNewPassword(isStrongPassword);
            if(!isStrongPassword) {
                errors.strongPassword = "Required";
            }
        }

        if(values.phone?.length > 0) {
            const isValidPhone = validator.isMobilePhone(values.phone, "vi-VN");
            setIsValidPhone(isValidPhone);
            if(!isValidPhone) {
                errors.validPhone = "Required";
            }
        }

        if(values.email?.length > 0) {
            const isValidEmail = validator.isEmail(values.email);
            setIsValidEmail(isValidEmail);
            if(!isValidEmail) {
                errors.validEmail = "Required";
            }
        }

        if(cookies?.loginCookie?.data?.roles === 'super_admin') {
            if(!values.selected_company_id) {
                errors.selected_company_id = "Required";
            }
        }

        return errors;
    }

    const onSubmit = async(values) => {
        setIsProcessing(true);
        try
        {
            let portrait_url = null;

            if(portraitFile) {
                // upload portrait
                let portraitFiledata = new FormData();
                portraitFiledata.append('uri', portraitFile);

                let resUpload = await axios.post(`${process.env.REACT_APP_API_ENDPOINT_URL}/upload?subPath=users`, portraitFiledata, { 
                    headers: { "Content-Type": "multipart/form-data" },
                    auth: {
                        username: process.env.REACT_APP_BASIC_AUTH_USERNAME,
                        password: process.env.REACT_APP_BASIC_AUTH_PASSWORD
                    }
                });

                if(resUpload.data?.status === 200) {
                    portrait_url = resUpload.data.fileName;
                }
            }

            apiCreateNewUser({ 
                ...values,
                portrait_url,
                company_id: values.selected_company_id || company_id,
                user_id: cookies?.loginCookie?.data?.id,
            });
        }
        catch(error) {
            if(error?.code) {
                toast({
                    description: `${ERROR_CODES[error?.code]} (${error?.code})`,
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                    position: "bottom-right"
                });
            }
        }
    }

    return (
        <Modal initialFocusRef={initialRef} isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false} size="md">
            <ModalOverlay />
            <Form
                onSubmit={onSubmit}
                initialValues={{
                    company_id
                }}
                validate={validate}
                render={({ handleSubmit, form, submitting, pristine, valid, values }) => {
                    return (
                        <form onSubmit={handleSubmit} autoComplete='off'>
                            <ModalContent>
                                <ModalHeader>
                                    TẠO MỚI
                                </ModalHeader>
                                <ModalCloseButton />

                                <ModalBody pb={6}>
                                    <HStack align="flex-start">
                                        <VStack width="100%">
                                            {
                                                cookies?.loginCookie?.data?.roles === 'super_admin' &&
                                                <Field name="selected_company_id">
                                                    {({ input, meta }) => (
                                                        <FormControl isRequired>
                                                            <FormLabel>Phòng Khám</FormLabel>
                                                            <Select {...input} placeholder='Chọn phòng khám'>
                                                                {
                                                                    companyList.map(item => (
                                                                        <React.Fragment key={item.id}>
                                                                            <option value={item.id}>{item.name}</option>
                                                                        </React.Fragment>
                                                                    ))
                                                                }
                                                            </Select>
                                                        </FormControl>
                                                    )}
                                                </Field>
                                            }

                                            <Field name="phone">
                                                {({ input, meta }) => (
                                                    <FormControl isRequired>
                                                        <FormLabel>Số Điện Thoại</FormLabel>
                                                        <Input {...input} type='text' placeholder='Nhập số điện thoại' />
                                                        {
                                                            !isValidPhone &&
                                                            <FormLabel color="red">Nhập đúng Số Điện Thoại</FormLabel>
                                                        }
                                                    </FormControl>
                                                )}
                                            </Field>

                                            <Field name="email">
                                                {({ input, meta }) => (
                                                    <FormControl isRequired>
                                                        <FormLabel>Email</FormLabel>
                                                        <Input {...input} type='email' placeholder='Nhập Email'/>
                                                        {
                                                            !isValidEmail &&
                                                            <FormLabel color="red">Nhập đúng Email</FormLabel>
                                                        }
                                                    </FormControl>
                                                )}
                                            </Field>

                                            <Field name="full_name">
                                                {({ input, meta }) => (
                                                    <FormControl isRequired>
                                                        <FormLabel>Họ tên</FormLabel>
                                                        <Input {...input} type='text' placeholder='Nhập Họ tên' />
                                                    </FormControl>
                                                )}
                                            </Field>

                                            <Field name="password">
                                                {({ input, meta }) => (
                                                    <FormControl isRequired>
                                                        <FormLabel>Mật khẩu</FormLabel>
                                                        <InputGroup>
                                                            <Input {...input} type={showPassword ? 'text' : 'password'} placeholder='Nhập mật khẩu' autoComplete="off" 
                                                                onCopy={(e) => {e.preventDefault()}} onPaste={(e) => {e.preventDefault()}}
                                                            />

                                                            <InputRightElement width="3rem">
                                                                <Button h="1.5rem" size="sm" onClick={handlePasswordVisibility}>
                                                                    {showPassword ? <ViewOffIcon /> : <Icon as={ViewIcon} />}
                                                                </Button>
                                                            </InputRightElement>
                                                        </InputGroup>
                                                        {
                                                            !isValidNewPassword &&
                                                            <FormLabel color="red">(Độ dài tối thiểu 8 ký tự bao gồm ít nhất 1 chữ in hoa, 1 chữ in thường và 1 ký tự số)</FormLabel>
                                                        }
                                                    </FormControl>
                                                )}
                                            </Field>
                                            
                                            <Field name="confirm_password">
                                                {({ input, meta }) => (
                                                    <FormControl isRequired>
                                                        <FormLabel>Nhập lại mật khẩu</FormLabel>
                                                        <InputGroup>
                                                            <Input {...input} type={showConfirmPassword ? 'text' : 'password'} placeholder='Nhập lại mật khẩu' 
                                                                onCopy={(e) => {e.preventDefault()}} onPaste={(e) => {e.preventDefault()}}
                                                            />

                                                            <InputRightElement width="3rem">
                                                                    <Button h="1.5rem" size="sm" onClick={handleConfirmPasswordVisibility}>
                                                                        {showConfirmPassword ? <ViewOffIcon /> : <Icon as={ViewIcon} />}
                                                                    </Button>
                                                                </InputRightElement>
                                                        </InputGroup>
                                                    </FormControl>
                                                )}
                                            </Field>

                                            <Field name="roles">
                                                {({ input, meta }) => (
                                                    <FormControl isRequired>
                                                        <FormLabel>Quyền Truy cập</FormLabel>
                                                        <Select {...input} placeholder='Chọn Quyền truy cập'>
                                                            {
                                                                Object.keys(ROLES).map(key => (
                                                                    <React.Fragment key={key}>
                                                                        <option value={key}>{ROLES[key]}</option>
                                                                    </React.Fragment>
                                                                ))
                                                            }
                                                        </Select>
                                                    </FormControl>
                                                )}
                                            </Field>
                                            
                                            <FormControl>
                                                <FormLabel>Ảnh đại diện</FormLabel>
                                                <DropZoneWithImage callback={setPortraitFile}/>
                                            </FormControl>
                                        </VStack>
                                    </HStack>
                                </ModalBody>

                                <ModalFooter>
                                    <Button colorScheme='blue' mr={3} type='submit' isDisabled={!valid | pristine}
                                        isLoading={isProcessing}
                                        loadingText="Đang lưu"
                                    >
                                        <Icon boxSize={6} as={MdSave} marginRight="8px"/> 
                                        <Text fontSize="14px">Lưu</Text>
                                    </Button>
                                </ModalFooter>
                            </ModalContent>
                        </form>
                    )
                }}
            />
        </Modal>
    )
}

export default AddEditUserModal;